<template>
  <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.33645 0.721924L0.721933 7.33644L0.930176 7.54358L0.896 7.57718L7.51052 14.1917L9.63184 12.0704L4.93218 7.36958L9.45777 2.84324L7.33645 0.721924Z" fill="white"/>
  </svg>
</template>